import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup } from '@angular/forms';

@Pipe({
    name: 'characterCounter',
    pure: false //ensuraes real time updates
    ,
    standalone: false
})
export class CharacterCounterPipe implements PipeTransform {

  transform(control: AbstractControl | null, maxLength: number = 2000, fieldName?: string): string {
    if (!control) return `0/${maxLength}`;
    
    let value = '';

    if (control instanceof FormControl) {
      value = control.value || '';
    } 
    else if (control instanceof FormArray) {
      value = this.getFormArrayValue(control, fieldName);
    } 
    else if (control instanceof FormGroup && fieldName) {
      value = this.getFormGroupValue(control, fieldName);
    }

    value = value?.replace(/\s+/g, ''); // Remove spaces before counting

    return `${value.length}/${maxLength}`;
  }

  private getFormArrayValue(formArray: FormArray, fieldName?: string): string {
    return formArray.controls
      .map(control => this.getAbstractControlValue(control, fieldName))
      .join('');
  }

  private getFormGroupValue(formGroup: FormGroup, fieldName: string): string {
    const fieldControl = formGroup.get(fieldName);
    if (fieldControl instanceof FormControl) {
      return (fieldControl.value || '').toString();
    }
    return '';
  }

  private getAbstractControlValue(control: AbstractControl, fieldName?: string): string {
    if (control instanceof FormControl) {
      if (fieldName && typeof control.value === 'object' && control.value[fieldName]) {
        return control.value[fieldName].toString();
      }
      return (control.value || '').toString();
    }
    if (control instanceof FormArray) {
      return this.getFormArrayValue(control, fieldName);
    }
    return '';
  }
}
